/* global axios */
import ApiClient from './ApiClient';

class PdvSalesReportsAPI extends ApiClient {
  constructor() {
    super('pdv_sales_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getSummary({ since, until, groupBy, agentId } = {}) {
    return axios.get(`${this.url}/summary`, {
      params: { since, until, group_by: groupBy, agent_id: agentId },
    });
  }

  getAgents({ since, until } = {}) {
    return axios.get(`${this.url}/agents`, {
      params: { since, until },
    });
  }

  getProducts({ since, until, agentId, limit } = {}) {
    return axios.get(`${this.url}/products`, {
      params: { since, until, agent_id: agentId, limit },
    });
  }

  getPayments({ since, until, agentId } = {}) {
    return axios.get(`${this.url}/payments`, {
      params: { since, until, agent_id: agentId },
    });
  }

  getProductAgents({ since, until, productId } = {}) {
    return axios.get(`${this.url}/product_agents`, {
      params: { since, until, product_id: productId },
    });
  }

  getSales({ since, until, agentId, status, q, page, perPage } = {}) {
    return axios.get(`${this.url}/sales`, {
      params: {
        since,
        until,
        agent_id: agentId,
        status,
        q,
        page,
        per_page: perPage,
      },
    });
  }
}

export default new PdvSalesReportsAPI();
